import { api, IFavoriteCategoryApi } from '@/main/api/base';
import { Result } from '@/main/models/common/resultResponse';
import { SaveFavoriteCategory } from '@/main/models/request';
import { FavoriteCategoryResponse } from '@/main/models/response';
import { AxiosResponse } from 'axios';

const baseRoute: string = 'FavoriteCategory';
export class FavoriteCategoryApi implements IFavoriteCategoryApi {
  save(request: SaveFavoriteCategory): Promise<AxiosResponse<Result<boolean>>> {
    return api.post(`${baseRoute}/save`, request);
  }

  getDetails(): Promise<AxiosResponse<Result<FavoriteCategoryResponse>>> {
    return api.get(`${baseRoute}/detail`);
  }
}
